{
  "view": {
    "title": "Terminate the agreement",
    "rightOfOccupancyNoticeTitle": "Submit a notice of handover",
    "description": "On this page you can submit an electronic notice of termination.",
    "rightOfOccupancyNoticeDescription": "On this page you can submit an electronic notice of handover.",
    "contractContinuesInfo": "If everyone moves out, the contract ends. If a contract party moves out and an adult resident stays in the apartment, the contract can continue in their name.",
    "residentChangesInfo": "Moves of residents who are not contract parties are reported on the Resident changes page."
  },
  "links": {
    "goToResidentChanges": "Go to resident changes →",
    "seeResidentChanges": "See Resident changes →"
  },
  "headings": {
    "parties": "Parties",
    "terminateForm": "Termination form",
    "rentalTermination": "Termination of rental agreement",
    "rightOfOccupancyNotice": "Notice of handover",
    "paymentAndContactInfo": "Payment and contact details",
    "paymentInfo": "Payment details",
    "newAddress": "New address",
    "showing": "Viewing",
    "additionalDetails": "Additional information",
    "leavePreviewConfirmation": "Leave the form?",
    "terminationPreview": "Preview the termination",
    "rightOfOccupancyNoticePreview": "Preview the notice of handover",
    "confirmation": "Review the agreement notice",
    "basicInfo": "Basic information",
    "thankYou": "Thank you",
    "confirmationRejected": "The termination request has been rejected.",
    "rightOfOccupancyNoticeConfirmationRejected": "The notice of handover has been rejected.",
    "contactInformation": "Contact information",
    "terminationSituation": "What happens to the contract?"
  },
  "terminationSituations": {
    "wholeContract": "The whole contract ends",
    "wholeContractDescription": "The whole contract ends – all residents move out.",
    "contractContinues": "The contract continues",
    "contractContinuesDescription": "The contract continues – one or more contract parties move out, and the contract continues in the name of the contract party or adult resident who stays in the apartment."
  },
  "labels": {
    "movingOutDate": "Move-out date",
    "contractEndDate": "End date of the agreement",
    "terminationReason": "Primary reason for termination",
    "rightOfOccupancyNoticeReason": "Primary reason for the notice of handover",
    "movingDestination": "Where are you moving to",
    "files": "Attached documents",
    "beneficiaryName": "Account holder",
    "iban": "Account number",
    "bic": "BIC",
    "bankCountry": "Bank country",
    "returnPercentage": "Refundable portion of deposit/refunds",
    "rooReturnPercentage": "Refundable portion of the right-of-occupancy fee",
    "email": "Email address",
    "phoneNumber": "Telephone",
    "recipientName": "First name and last name",
    "streetAddress": "Street address",
    "streetAddressLine2": "Street address (line 2)",
    "postalCode": "Postcode",
    "city": "Post town",
    "countryName": "Country",
    "countrySubdivision": "Region",
    "showing": "Viewing of the apartment",
    "presenter": "Presenter",
    "additionalDetails": "Additional information",
    "givingContactInfoAllowed": "My contact details can be given to anyone interested in the apartment",
    "masterKeyAccessAllowed": "The master key may be used to enter my apartment",
    "hasPetsInApartment": "Pets in the apartment",
    "terminated": "Terminated",
    "rightOfOccupancyNoticeSubmitted": "Notice of handover submitted",
    "rightOfOccupancyCollateralLocation": "Right-of-occupancy agreement",
    "bank": "Bank"
  },
  "placeholders": {
    "additionalDetails": "Enter additional information related to the termination",
    "rightOfOccupancyNoticeAdditionalDetails": "Enter additional information related to the notice of handover"
  },
  "alt": {
    "successIllustration": "Thank you illustration"
  },
  "buttons": {
    "backToEdit": "Back to the editing view",
    "continueFilling": "Yes",
    "leavePreview": "No",
    "confirmTermination": "Proceed to confirmation",
    "rejectTermination": "Reject the termination",
    "confirmRightOfOccupancyNotice": "Confirm the notice of handover",
    "rejectRightOfOccupancyNotice": "Reject the notice of handover",
    "restart": "Start from the beginning",
    "back": "Back"
  },
  "texts": {
    "confirmationInstruction": "Review the submitted information and either approve or reject the termination on your part. If the information needs to be edited, reject the termination and fill out the termination form again.",
    "confirmationInstructionReview": "Carefully review the information you have provided.",
    "confirmationInstructionConfirm": "Select <strong>{{confirmButtonLabel}}</strong> and proceed to identification.",
    "confirmationInstructionEdit": "If the information needs editing, select <strong>{{backToEditButtonLabel}}</strong>.",
    "terminationNoticeSentAfterConfirmation": "The notice of termination will only be sent after confirmation.",
    "rightOfOccupancyNoticeSentAfterConfirmation": "The notice of handover will only be sent after confirmation.",
    "terminationNoticeBeforeConfirmationInstruction": "Review the information in the next step and confirm the termination by identifying yourself.",
    "leavePreviewConfirmation": "You are about to leave the form. If you leave the form, the information you have entered will not be saved. Do you want to continue filling in the form?",
    "additionalDetailsInfo": "You can provide additional information related to the termination of the agreement here. For example, you can add details about apartment viewings, payment refunds or pets.",
    "rightOfOccupancyNoticeAdditionalDetailsInfo": "You can provide additional information related to the notice of handover of the agreement here. For example, you can add details about apartment viewings, payment refunds or pets.",
    "rightOfOccupancyNoticeBeforeConfirmationInstruction": "Review the information in the next step and confirm the notice of handover by identifying yourself.",
    "movingOutDateTooltip": "The apartment is empty, cleaned and the keys have been returned.",
    "contractEndDateTooltip": "If you wish, you can change the end date of the agreement to a later date.",
    "terminationReasonTooltip": "If there are several reasons, select the most important one.",
    "securityRestrictionWarning": "You have a valid non-disclosure for personal safety reasons, so the address information you provide will not be shown to others, including the other parties to this agreement.",
    "terminateInstructions": "The final date of validity of the agreement is exactly 3 months after the notice of handover, which is, at the earliest {{endDate}}. If you wish, you can change the expiry date to a later date.",
    "uploadFiles": "Add an attachment by clicking or dropping it here\nThe maximum size is 10 MB",
    "addReceipts": "If modifications have been made to the apartment but the receipts have not yet been submitted, attach them here.",
    "paymentInfoReason": "Add your account details for the return of the deposit and any other payments. The refundable portions must total 100%. Complete the details even if the deposit is not returned directly to you. If refunds are made to more than one account, select Add payment details and enter the details. Then divide the refunds by entering the percentage for each refund. You can provide additional information about refunds in the Additional information field at the end of the form.",
    "paymentInfoReasonRental": "Add your account details for the return of the deposit and any other payments. The refundable portions must total 100%. Complete the details even if the deposit is not returned directly to you. If refunds are made to more than one account, select Add payment details and enter the details. Then divide the refunds by entering the percentage for each refund. You can provide additional information about refunds in the Additional information field at the end of the form.",
    "paymentInfoCollateralBankInstructions": "Return the hard-copy right-of-occupancy agreement by {{endDate}} to the following address:\n\n{{companyName}}\n{{companyAddress}}",
    "paymentInfoCollateralBankInstructionsNoAddress": "Return the hard-copy right-of-occupancy agreement by {{endDate}} to the right-of-occupancy office.",
    "addPaymentInfo": "Add payment details",
    "bankCountryWithoutIban": "The account number must be entered in IBAN format. If your account does not have an IBAN, please contact customer service.",
    "newAddressReason": "We need your address so that we can send information and possible letters concerning the end of the agreement, if necessary. If your new address is not yet known, you can leave this section empty. If there is more than one address, for example if you are moving to different addresses, you can provide additional information in the Additional information field at the end of the form.",
    "showingInstructions": "The most convenient way is to arrange viewings with the people coming to see the apartment. However, if you do not allow us to pass on your contact details, viewings can also be agreed through the company.",
    "showingInstructions2": "If you choose that the company will show the apartment, you also agree that the apartment can be entered with a master key. The time of the viewing will be agreed between the parties and the resident will be notified of the viewing at least 24 hours in advance.",
    "selectedAsPresenter": "You have been selected as the presenter.",
    "terminationNotice": "Notice of termination",
    "movingDestinationInstructions": "Leave it empty if you do not know",
    "terminateInstructionsRental": "The final date of validity of the agreement is the end of the next full calendar month, which is, at the earliest {{endDate}}. If you wish, you can change the expiry date to a later date.",
    "monthEndDateUnavailable": "There are no month-end dates available in the selected range. Please contact customer service.",
    "propertyCompanyName": null,
    "propertyCompanyAddress": null,
    "propertyCompanyAddressError": "Error when searching for the delivery address of the right-of-occupancy agreement.",
    "confirmationAccepted": "The termination request has been confirmed on your part.",
    "rightOfOccupancyNoticeConfirmationAccepted": "The notice of handover has been confirmed on your part.",
    "fixedTermAlert": "Please note that a fixed-term contract cannot generally be terminated. However, you can end it prematurely, for example, due to relocation to another municipality or illness. Please attach the necessary documents.",
    "terminationReturnFromAuthReminder": "Please note that the termination notice is only submitted for processing once you have completed strong authentication and returned to the resident pages. If authentication is interrupted, the termination remains incomplete.",
    "rightOfOccupancyNoticeReturnFromAuthReminder": "Please note that the notice of surrender is only submitted for processing once you have completed strong authentication and returned to the resident pages. If authentication is interrupted, the notice of surrender remains incomplete.",
    "allTenantsMoveOutDescription": "The contract ends for everyone. Each contract party confirms the termination with their own identification.",
    "rightOfOccupancyNoticeAllTenantsMoveOutDescription": "The contract ends for everyone. Each contract party confirms the notice of handover with their own identification."
  },
  "terminateContractReasons": {
    "buyingProperty": "Buying an owner-occupied home",
    "moveToAnotherRental": "Moving to a rental apartment",
    "moveToRightOfOccupancy": "Moving to a right-of-occupancy apartment",
    "moveToCareHomeOrHospital": "Moving to serviced accommodation or a hospital",
    "moveDueWork": "Moving for work or study",
    "moveToAnotherMunicipality": "Change of municipality",
    "familySizeChange": "Family changes (divorce, marriage/cohabitation, child)",
    "apartmentSize": "Apartment size",
    "poorApartmentCondition": "Apartment in bad condition",
    "poorApartmentEquipmentOrProperties": "Equipment and/or characteristics of the apartment",
    "poorPropertyCondition": "Property in bad condition",
    "poorPropertyMaintenance": "Bad property maintenance",
    "housingCosts": "Housing costs",
    "disturbingNeighboursOrBuilding": "Disruptive neighbours/disturbance in the building",
    "areaPoorServices": "Bad services in the area",
    "poorTransportationOptions": "Bad transport connections",
    "moveToAnotherApartmentOfSameOwner": "Moving to another apartment with the same owner",
    "death": "Death",
    "apartmentDoesNotMeetNeeds": "Apartment does not meet my needs",
    "apartmentTemperature": "Apartment temperature",
    "apartmentLocation": "Apartment location",
    "studiesEnd": "Studies ending",
    "rightOfOccupancyEnds": "Right of occupancy ending",
    "areaDisturbances": "Disturbances in the living environment",
    "healthReasons": "Health reasons",
    "eviction": "Eviction",
    "renovation": "Major renovation / renovation",
    "businessClosure": "Business operations ending",
    "businessClosureInMunicipality": "Business operations in the municipality ending",
    "businessStructureChange": "Change in company structure",
    "spaceNeedsChange": "Change in space requirements",
    "moveToMoreAffordableBusinessPremisesInMunicipality": "Moving to more affordable premises in the same municipality",
    "other": "Other reason",
    "unknown": "Not known"
  },
  "terminationDestinations": {
    "buyingProperty": "Buying an owner-occupied home",
    "moveToAnotherApartmentOfSameOwner": "Moving to another rental apartment with the same owner",
    "moveToAnotherRental": "Moving to a rental apartment with another provider",
    "moveToRightOfOccupancyOfSameOwner": "Moving to a right-of-occupancy apartment with the same owner",
    "moveToRightOfOccupancyOfAnotherOperator": "Moving to a right-of-occupancy apartment with another provider",
    "moveToRightOfOccupancy": "Moving to a right-of-occupancy apartment",
    "moveToCareHomeOrHospital": "Moving to serviced accommodation or a hospital",
    "other": "Other reason",
    "unknown": "Not known"
  },
  "showingSuggestions": {
    "tenant": "The resident will conduct viewings",
    "propertyCompanyGroup": "Company will conduct viewings"
  },
  "terminateSuggestions": {
    "terminate": "Terminate",
    "rightOfOccupancyNotice": "Notice of handover",
    "inEffect": "Valid",
    "pending": "Waiting"
  },
  "rightOfOccupancyCollateralLocationSuggestions": {
    "bank": "As collateral for the loan",
    "holder": "By the resident"
  },
  "terminationDisallowedReason": {
    "contractTerminated": "The agreement has been terminated.",
    "pendingTerminationTenantApprovals": "The termination of the agreement is awaiting approval by one or more parties.",
    "rightOfOccupancyNoticePendingTenantApprovals": "The notice of handover is awaiting approval by one or more parties.",
    "pendingTerminationReview": "The agreement is awaiting approval of termination.",
    "isEstateContract": "The agreement is a death estate.",
    "hasGuardianOfInterests": "You cannot terminate the apartment electronically because a legal guardian has been appointed for one or more residents.",
    "missingResidentUsers": "Not all adult tenants have user accounts for the resident pages.",
    "multipleContractParties": "It is not yet possible to terminate an agreement with several parties on the resident pages.",
    "contractTags": "The agreement cannot be terminated electronically. Please contact our customer service team.",
    "notContractParty": "You cannot terminate the agreement electronically, because you are not a party to the agreement.",
    "tenantsWithUndeterminedAge": "The agreement cannot be terminated electronically because some personal data is missing. Please contact customer service.",
    "hasCompanyTenant": "Agreements with a company party cannot be terminated electronically. Please contact customer service.",
    "pendingModificationContract": "There is an open modification request for the agreement.",
    "pendingContractParty": "You cannot terminate the tenancy electronically before the contract changes take effect.",
    "notStartedYet": "The agreement has not yet started.",
    "openContinuationOffer": "There is an open continuation offer for the agreement, and contract changes cannot be made from the resident pages.",
    "pendingContractResign": "The contract is waiting for re-signing."
  },
  "confirmationError": {
    "noIdentityVerifier": "User's identity could not be verified",
    "noIdentity": "User's identity could not be processed",
    "noUser": "An error occurred while retrieving the user's data",
    "noAttributes": "User's personal data is incomplete",
    "identityMismatch": "Identity does not match the logged-in user",
    "initFailed": "An error occurred while confirming the notice of termination",
    "cancelled": "Identification cancelled",
    "addTenantInitFailed": "Adding the resident failed",
    "movingOutDateNoLongerValid": "The moving-out date is no longer valid",
    "missingResidentCredentials": "The agreement cannot be terminated at this time, because one or more contract parties or payers do not have resident app credentials.",
    "pendingTerminationRequest": "A notice of termination has already been submitted for this agreement, so a new notice cannot be sent."
  },
  "confirmationPendingText": "Identity verified: You can now terminate the contract.",
  "confirmTerminationButtonText": "Terminate the agreement",
  "confirmationErrorText": "An error occurred while sending the notice of termination",
  "confirmErrorText": "An error occurred while confirming the termination",
  "confirmationBackButtonText": "Go back",
  "confirmationClientError": {
    "nonceDiffFailed": "An error occurred while verifying the form",
    "formValuesMissing": "Some of the information on the notice of termination is missing or incorrect",
    "missingContractId": "Missing or incorrect contract ID"
  },
  "confirmationState": {
    "confirmed": "Thank you. The notice of termination has been sent. You will receive an automatic email confirming that we have received the notice. We will process your notice as soon as possible. If you do not receive a message, please contact customer service.",
    "rightOfOccupancyNoticeConfirmed": "Thank you. The notice of handover has been sent. You will receive an automatic email confirming that we have received the notice. We will process your notice as soon as possible. If you do not receive a message, please contact customer service.",
    "pending": "The notice of termination has been sent and is waiting for other approvals",
    "rightOfOccupancyNoticePending": "The notice of handover has been sent and is waiting for other approvals",
    "rejected": "Cancelled sending the notice of termination",
    "rightOfOccupancyNoticeRejected": "Cancelled sending the notice of handover",
    "notFound": "No information on the sending ID of the notice of termination",
    "rightOfOccupancyNoticeNotFound": "No information on the sending ID of the notice of handover",
    "loading": "Loading the sending status of the notice of termination"
  },
  "errors": {
    "outOfService": "Unfortunately, it is not possible to terminate the contract at this time. Please try again later.",
    "tooEarlyToTerminate": "Termination is possible only after the contract has come into effect.",
    "tooEarlyToTerminateMessage": "Contact customer service if necessary.",
    "passportIdentityTerminateDisabled": "Termination is not possible yet when identified with a passport.",
    "passportIdentityTerminateDisabledMessage": "Contact customer service if necessary.",
    "terminationRequestUnavailable": "The notice of termination cannot be shown right now because the contract details are being updated."
  }
}
